import BaseApi from "../../BaseApi";
import { headers } from "../../ApiSettings";

class Shop extends BaseApi {
  constructor() {
    super({ suffix: "" });
  }

  getFrameTemplates(params) {
    return this.httpService.get("shop/setting/frame-template", {
      headers,
      params,
    });
  }

  getGroupTemplates(params) {
    return this.httpService.get("shop/setting/group-template", {
      headers,
      params,
    });
  }

  insertGroupTemplate(data) {
    return this.httpService.post("shop/setting/group-template", data, {
      headers,
    });
  }

  editGroupTemplate(data) {
    return this.httpService.put("shop/setting/group-template", data, {
      headers,
    });
  }

  deleteGroupTemplate(data) {
    return this.httpService.delete("shop/setting/group-template", {
      headers,
      data,
    });
  }

  getComboTemplates(params) {
    return this.httpService.get("shop/setting/combo-template", {
      headers,
      params,
    });
  }

  getTemplates(params) {
    return this.httpService.get("shop/setting/template", {
      headers,
      params,
    });
  }

  insertTemplate(data) {
    return this.httpService.post("shop/setting/template", data, {
      headers,
    });
  }

  editTemplate(data) {
    return this.httpService.put("shop/setting/template", data, {
      headers,
    });
  }

  deleteTemplate(data) {
    return this.httpService.delete("shop/setting/template", {
      headers,
      data,
    });
  }

  getSettingProjects(params) {
    return this.httpService.get("shop/setting/project", {
      headers,
      params,
    });
  }

  insertSettingProject(data) {
    return this.httpService.post("shop/setting/project", data, {
      headers,
    });
  }

  editSettingProject(data) {
    return this.httpService.put("shop/setting/project", data, {
      headers,
    });
  }

  deleteSettingProject(data) {
    return this.httpService.delete("shop/setting/project", {
      headers,
      data,
    });
  }

  getSettingUnitInfo(params) {
    return this.httpService.get("shop/setting/unit-standard", {
      headers,
      params,
    });
  }

  updateSettingUnitInfo(data) {
    return this.httpService.post("shop/setting/unit-standard", data, {
      headers,
    });
  }

  getSettingUnitAttachments(params) {
    return this.httpService.get("shop/setting/unit-link", {
      headers,
      params,
    });
  }

  insertSettingUnitAttachment(data) {
    return this.httpService.post("shop/setting/unit-link", data, {
      headers,
    });
  }

  editSettingUnitAttachment(data) {
    return this.httpService.put("shop/setting/unit-link", data, {
      headers,
    });
  }

  deleteSettingUnitAttachment(data) {
    return this.httpService.delete("shop/setting/unit-link", {
      headers,
      data,
    });
  }

  getSettingGlasses(params) {
    return this.httpService.get("shop/setting/glass", {
      headers,
      params,
    });
  }

  insertSettingGlass(data) {
    return this.httpService.post("shop/setting/glass", data, {
      headers,
    });
  }

  editSettingGlass(data) {
    return this.httpService.put("shop/setting/glass", data, {
      headers,
    });
  }

  deleteSettingGlass(data) {
    return this.httpService.delete("shop/setting/glass", {
      headers,
      data,
    });
  }
}

const ShopService = new Shop();
export default ShopService;
